const ProgramNavItems = [
  {viewBy: 'all', title: 'All'},
  {viewBy: 'video', title: 'Video Concerts'},
  {viewBy: 'audio', title: 'Audio Concerts'}
]

export default ProgramNavItems